import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";
import { LoaderOverlayProps } from "./types";

export function LoaderOverlay({
  visible,
  message = "Loading view...",
}: LoaderOverlayProps) {
  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center surface-overlay z-5">
      <div className="flex flex-column align-items-center gap-3 p-4 border-round surface-card shadow-2">
        <ProgressSpinner
          style={{ width: "40px", height: "40px" }}
          strokeWidth="4"
        />
        <span className="text-600">{message}</span>
      </div>
    </div>
  );
}
